var _ellipse, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableChairESelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10,
  cy: 11,
  fill: "#464D57",
  rx: 6,
  ry: 7.2,
  transform: "rotate(90 10 11)"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "NoTable-Chair-E-Selected_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.2 13.4c0 1.304.594 2.598 1.813 3.061.91.346 1.921.54 2.987.54a8.402 8.402 0 0 0 2.986-.54c1.22-.463 1.814-1.757 1.814-3.06a4.8 4.8 0 1 0-9.6 0Z",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  d: "M10 15c-.825 0-1.595-.15-2.276-.408L6.302 18.33c1.139.433 2.391.67 3.698.67v-4Zm2.275-.408A6.403 6.403 0 0 1 10 15v4a10.4 10.4 0 0 0 3.697-.67l-1.422-3.738ZM10 10.6a2.8 2.8 0 0 1 2.8 2.8h4A6.8 6.8 0 0 0 10 6.6v4Zm-2.8 2.8a2.8 2.8 0 0 1 2.8-2.8v-4a6.8 6.8 0 0 0-6.8 6.8h4Zm6.497 4.93c2.272-.863 3.103-3.137 3.103-4.93h-4c0 .362-.085.67-.2.878-.106.192-.22.274-.325.314l1.422 3.739Zm-5.973-3.738c-.105-.04-.218-.122-.324-.314a1.853 1.853 0 0 1-.2-.878h-4c0 1.793.83 4.066 3.102 4.93l1.422-3.738Z",
  mask: "url(#NoTable-Chair-E-Selected_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M2.8 12.2V11c0-3.314 3.223-6 7.2-6 3.976 0 7.2 2.686 7.2 6v1.2"
})));
SvgNoTableChairESelected.viewBox = '0 0 20 20';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableChairESelected);
export default ForwardRef;